module.exports = "/_next/static/images/Unify@2x-37748c9b711faacf6998f1a3a7a97cc0.webp";